module.exports = __webpack_public_path__ + "static/media/acelormittal.5f0ec576.png";